import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { ShowCardUser } from 'components/showCard/showCardUser'
import { useFilteredShowsByYear } from 'hooks/user/useShows'
import { useState } from 'react'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import { ShowWithImages } from 'types/Show'

import { SelectSeason } from './components/selectSeason'
import { Container, ContainerWrapper } from './showListUser.style'

interface Props {
    data: ShowWithImages[]
}

export const ShowListUser = ({ data }: Props) => {
    const currentYear = new Date().getFullYear()
    const [season, setSeason] = useState<number>(currentYear)
    const { filteredShows, isLoading, error } = useFilteredShowsByYear(data, season)

    const handleSeasonChange = (change: number) => {
        setSeason((prevSeason) => prevSeason + change)
    }

    return (
        <Container>
            <ContainerWrapper>
                <LoadingContainer isLoading={isLoading} error={error}>
                    <SelectSeason season={season} onPreviousYear={() => handleSeasonChange(-1)} onNextYear={() => handleSeasonChange(1)} />
                    {filteredShows.length > 0 ? (
                        <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 4 }}>
                            <Masonry columnsCount={4} gutter="16px">
                                {filteredShows.map((show) => (
                                    <ShowCardUser
                                        key={show.show_id}
                                        show_id={show.show_id}
                                        image={show.cover_image}
                                        title={show.name}
                                        description={show.description}
                                    />
                                ))}
                            </Masonry>
                        </ResponsiveMasonry>
                    ) : (
                        <PlaceholderContainer>
                            <p>Hamarosan új előadások érkeznek!</p>
                        </PlaceholderContainer>
                    )}
                </LoadingContainer>
            </ContainerWrapper>
        </Container>
    )
}
